import orderCategory from '@data/fragments/categories/orderCategory'
import getClient from '@providers/apollo/getClient'
import gql from 'graphql-tag'

import {
  getCategoriesAndProductsCPGsWeb_cached,
  getCategoriesAndProductsCPGsWeb_cachedVariables
} from './__generated__/getCategoriesAndProductsCPGsWeb_cached'
import {
  getCategoriesAndProductsWeb_cached,
  getCategoriesAndProductsWeb_cachedVariables
} from './__generated__/getCategoriesAndProductsWeb_cached'

export const categoriesForStoreQuery = gql`
  query getCategoriesAndProductsWeb_cached($websiteId: ID, $menuId: ID, $format: String) {
    categories(websiteId: $websiteId) {
      items {
        _id
        ...orderCategory
        brand {
          _id
          name
          menuImage {
            _id
            url
          }
          categoriesImage {
            _id
            url
          }
        }
      }
    }
  }
  ${orderCategory}
`

export const categoriesForCPGQuery = gql`
  query getCategoriesAndProductsCPGsWeb_cached($websiteId: ID, $menuId: ID, $format: String) {
    categories(websiteId: $websiteId) {
      items {
        _id
        ...orderCategory
        brand {
          _id
          name
          menuImage {
            _id
            url
          }
          categoriesImage {
            _id
            url
          }
        }
        subCategories {
          items {
            _id
            name
          }
        }
      }
    }
  }
  ${orderCategory}
`

export async function getCategoriesForWebsite({
  websiteId,
  menuId,
  format = 'webp'
}: {
  websiteId: string
  menuId: string
  format?: string
}) {
  const {data} = await getClient().query<
    getCategoriesAndProductsWeb_cached,
    getCategoriesAndProductsWeb_cachedVariables
  >({
    query: categoriesForStoreQuery,
    variables: {
      websiteId,
      menuId,
      format
    }
  })

  return data.categories
}

export async function getCategoriesForCPGWebsite({
  websiteId,
  menuId,
  format = 'webp'
}: {
  websiteId: string
  menuId: string
  format?: string
}) {
  const {data} = await getClient().query<
    getCategoriesAndProductsCPGsWeb_cached,
    getCategoriesAndProductsCPGsWeb_cachedVariables
  >({
    query: categoriesForCPGQuery,
    variables: {
      websiteId,
      menuId,
      format
    }
  })

  return data.categories
}
